import {IController} from "angular";
import * as angular from "angular";

export class TimelineHeaderCtrl implements IController {
  isEnabled: any;
  onToggle: Function;

  constructor() {
  }
}

angular
  .module('bringoz.admin.lean-planning')
  .component('timelineHeader', {
    bindings: {
      isEnabled: '<',
      onToggle: '&'
    },
    template: require('./timeline-header.html').default,
    controller: TimelineHeaderCtrl
  });
